import { ITEMS, type InvItem, type ItemKind } from './items';
import type { Game } from './game';

export type PaperKind = 'map' | 'note' | 'page1' | 'page2' | 'page3';
export interface JournalEntry { kind: PaperKind; text: string }

export function isPaper(kind: ItemKind): kind is PaperKind {
  return kind === 'map' || kind === 'note' || kind === 'page1' || kind === 'page2' || kind === 'page3';
}

export function rememberPaper(g: Game, kind: PaperKind, body?: string): void {
  if (kind === 'map') g.flags.mapKnown = true;
  const text = body || (kind === 'map' ? '[저택 도면]\n지도(M)에서 저택의 전체 방 배치를 볼 수 있다.' : ITEMS[kind].desc);
  g.journal ??= [];
  let index = g.journal.findIndex(entry => entry.kind === kind && entry.text === text);
  if (index < 0) { index = g.journal.length; g.journal.push({ kind, text }); }
  g.journalIndex = index;
}

export function journalTitle(entry: JournalEntry): string {
  const heading = entry.text.match(/^\[([^\]]+)\]/)?.[1];
  return heading ?? ITEMS[entry.kind].name;
}

/** Physical pocket space needed by a bag, accounting for paper and shared stacks. */
export function slotsNeeded(inventory: InvItem[], contents: InvItem[]): number {
  const stacks = new Set(inventory.filter(it => ITEMS[it.kind].stack).map(it => it.kind));
  let slots = 0;
  for (const it of contents) {
    if (isPaper(it.kind)) continue;
    if (!ITEMS[it.kind].stack) { slots++; continue; }
    if (!stacks.has(it.kind)) { stacks.add(it.kind); slots++; }
  }
  return slots;
}

/** Old pocket/bag papers were already picked up and read. Unread floor notes stay put. */
export function migratePapers(g: Game): void {
  const keep = (it: InvItem) => {
    if (!isPaper(it.kind)) return true;
    rememberPaper(g, it.kind, it.text); return false;
  };
  for (const c of g.chars.values()) c.inventory = c.inventory.filter(keep);
  for (const item of g.items) if (item.bag && item.contents) item.contents = item.contents.filter(keep);
  g.items = g.items.filter(it => !it.id.startsWith('drop:') || keep(it));
  for (const entry of g.journal) if (entry.kind === 'map') g.flags.mapKnown = true;
}
